import { firstNameSchemaV4, lastNameSchemaV4 } from '@massilia/features'

/**
 * Ce qui empêche un voyageur de passer la validation du formulaire.
 *
 * Les champs d'identité ne sont montés qu'en mode édition de la carte : une
 * erreur portée par l'un d'eux n'avait aucun endroit où s'afficher, et
 * « Confirmer ma réservation » restait sans effet ni message. Le client cliquait
 * dans le vide, sans jamais savoir ce qu'on lui reprochait.
 *
 * On applique ici **les schémas mêmes** que le validateur du formulaire — pas
 * une copie de la règle — pour pouvoir montrer le problème sur la carte, et dès
 * l'ouverture de la page plutôt qu'après un clic mort.
 *
 * La cause de loin la plus fréquente est un nom que le GDS ne sait pas traiter :
 * accent, apostrophe, ponctuation. Le client peut le corriger, et lui seul le
 * doit — on ne réécrit pas en douce un nom qui doit correspondre au passeport.
 */
export function passengerErrorMessage(passenger: {
  firstName: string
  lastName: string
}): null | string {
  const lastName = lastNameSchemaV4.safeParse(passenger.lastName)
  if (!lastName.success) return lastName.error.issues[0]?.message ?? null

  const firstName = firstNameSchemaV4.safeParse(passenger.firstName)
  if (!firstName.success) return firstName.error.issues[0]?.message ?? null

  return null
}
